import React, { createContext, useCallback, useState, useContext } from 'react';

import { NotificationsContextData } from './interface';

const NotificationsContext = createContext<NotificationsContextData>(
  {} as NotificationsContextData,
);

export const NotificationsProvider: React.FC = ({ children }) => {
  const [_total, _setTotal] = useState(0);

  const setTotal = useCallback(pTotal => {
    _setTotal(pTotal);
  }, []);

  return (
    <NotificationsContext.Provider value={{ total: _total, setTotal }}>
      <>{children}</>
    </NotificationsContext.Provider>
  );
};

export function useNotifications(): NotificationsContextData {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error('hook usada fora de contexto de notificações!');
  }
  return context;
}
